const MANAGEMENT_ENDPOINT = {
  CAMPAINGN: '/manage/campaigns',
  STREAM: '/manage/campaigns/stream'
};

export default MANAGEMENT_ENDPOINT;
